'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hour;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/hour.js
// module id = 162
// module chunks = 0